export default {
    listagem: {
        titulo_pagina: 'Revisar Resultados',
        table: {
            recipiente: 'Recipiente',
            informacoes: 'Informações',
            paciente: 'Paciente',
            exames: 'Exames',
            vns: 'VNS',
            empresa: 'Empresa',
            usuario_edicao: 'Usuário Editando',
            ultima_atualizacao: 'Última Atualização',
            acoes: 'Ações'
        },
        confirmacao_cancelamento: {
            titulo: 'Cancelamento',
            mensagem: 'Tem certeza que deseja cancelar os resultados dessa revisão? Esta ação não pode ser desfeita.'
        }
    },
    form: {
        titulo_pagina: 'Editar Resultados em Revisão',
        sem_resultados: 'Não há mais resultados para revisar.',
        outro_usuario: 'Este resultado está sendo editado por outro usuário.',
        fieldsets: {
            informacoes: 'Informações',
            exames: 'Exames'
        },
        fields: {
            recipiente: {
                label: 'Recipiente'              
            },
            paciente: {
                label: 'Paciente'
            },
            vns: {
                label: 'Vns',
            },
            empresa: {
                label: 'Empresa',
            },
            ultima_atualizacao: {
                label: 'Última Atualização'
            },
            exame: {
                label: 'Exame'                
            },
            exame_ordem: {
                label: 'Exame da Ordem'
            },
            material: {
                label: 'Material'
            },
            resultado: {
                label: 'Resultado'
            },
            unidade_medida: {
                label: 'Unidade de Medida'
            },
            erro_mapeamento: {
                label: 'Erro de Mapeamento',
                mensagem: 'Algum campo desse exame não foi mapeado corretamente.'
            },
            edit:{
                resultado: {
                    label: 'Novo Resultado',
                    description: 'Insira o novo resultado para o exame.'
                },
                unidade_medida: {
                    label: 'Nova Unidade de Medida',
                    description: 'Insira a nova unidade de medida para o exame.'
                },
                motivo: {
                    label: 'Motivo',
                    description: 'Explique o motivo da alteração.'
                }
            },
            cancelar_resultados: 'Cancelar Resultados',
            botao_salvar: 'Salvar Resultado e Enviar',
            botao_salvar_proximo: 'Salvar Resultado, Enviar e Ir para o Próximo',
        },
        update: {
            success: 'Resultado editado com Sucesso!',
            error: 'Error ao editar o Resultado!',
            warning: 'O resultado foi enviado para o sistema de origem.'
        },
        cancel: {
            success: 'Resultados cancelados com Sucesso!',
            error: 'Error ao cancelar os Resultados!'
        },
        list: {
            error: 'Ocorreu um erro ao tentar carregar os dados da tela!'
        },
        validation: {
            motivo_required: 'O motivo é obrigatório.',
            motivo_maxlength: 'O motivo não pode exceder 500 caracteres.',
            resultado_required: 'O resultado é obrigatório.',
            resultado_maxlength: 'O resultado não pode exceder 255 caracteres.',            
            unidade_medida_required: 'A unidade de medida é obrigatória.',
            unidade_medida_maxlength: 'A unidade de medida não pode exceder 255 caracteres.'
        }
    }
}
